// source: icws_proto/icws_api_gateway/storage/list_folder.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var icws_proto_icws_api_gateway_storage_storage_types_pb = require('../../../icws_proto/icws_api_gateway/storage/storage_types_pb.js');
goog.object.extend(proto, icws_proto_icws_api_gateway_storage_storage_types_pb);
var icws_proto_icws_api_gateway_storage_base_pb = require('../../../icws_proto/icws_api_gateway/storage/base_pb.js');
goog.object.extend(proto, icws_proto_icws_api_gateway_storage_base_pb);
goog.exportSymbol('proto.InkCapture.ListFolderRequest', null, global);
goog.exportSymbol('proto.InkCapture.ListFolderResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.InkCapture.ListFolderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.InkCapture.ListFolderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.InkCapture.ListFolderRequest.displayName = 'proto.InkCapture.ListFolderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.InkCapture.ListFolderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.InkCapture.ListFolderResponse.repeatedFields_, null);
};
goog.inherits(proto.InkCapture.ListFolderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.InkCapture.ListFolderResponse.displayName = 'proto.InkCapture.ListFolderResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.InkCapture.ListFolderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.InkCapture.ListFolderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.InkCapture.ListFolderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.ListFolderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    variant: jspb.Message.getFieldWithDefault(msg, 3, 0),
    includeScans: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    includeDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    rangeStart: jspb.Message.getFieldWithDefault(msg, 6, 0),
    rangeSize: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.InkCapture.ListFolderRequest}
 */
proto.InkCapture.ListFolderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.InkCapture.ListFolderRequest;
  return proto.InkCapture.ListFolderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.InkCapture.ListFolderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.InkCapture.ListFolderRequest}
 */
proto.InkCapture.ListFolderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.InkCapture.ImageVariantType} */ (reader.readEnum());
      msg.setVariant(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeScans(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeDeleted(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRangeStart(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRangeSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.InkCapture.ListFolderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.InkCapture.ListFolderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.InkCapture.ListFolderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.ListFolderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {!proto.InkCapture.ImageVariantType} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.InkCapture.ListFolderRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.InkCapture.ListFolderRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.setId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.clearId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.ListFolderRequest.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ImageVariantType variant = 3;
 * @return {!proto.InkCapture.ImageVariantType}
 */
proto.InkCapture.ListFolderRequest.prototype.getVariant = function() {
  return /** @type {!proto.InkCapture.ImageVariantType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.InkCapture.ImageVariantType} value
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.setVariant = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.clearVariant = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.ListFolderRequest.prototype.hasVariant = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool include_scans = 4;
 * @return {boolean}
 */
proto.InkCapture.ListFolderRequest.prototype.getIncludeScans = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.setIncludeScans = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.clearIncludeScans = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.ListFolderRequest.prototype.hasIncludeScans = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool include_deleted = 5;
 * @return {boolean}
 */
proto.InkCapture.ListFolderRequest.prototype.getIncludeDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.setIncludeDeleted = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.clearIncludeDeleted = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.ListFolderRequest.prototype.hasIncludeDeleted = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 range_start = 6;
 * @return {number}
 */
proto.InkCapture.ListFolderRequest.prototype.getRangeStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.setRangeStart = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.clearRangeStart = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.ListFolderRequest.prototype.hasRangeStart = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 range_size = 7;
 * @return {number}
 */
proto.InkCapture.ListFolderRequest.prototype.getRangeSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.setRangeSize = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.ListFolderRequest} returns this
 */
proto.InkCapture.ListFolderRequest.prototype.clearRangeSize = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.ListFolderRequest.prototype.hasRangeSize = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.InkCapture.ListFolderResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.InkCapture.ListFolderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.InkCapture.ListFolderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.InkCapture.ListFolderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.ListFolderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    documentsList: jspb.Message.toObjectList(msg.getDocumentsList(),
    icws_proto_icws_api_gateway_storage_base_pb.Document.toObject, includeInstance),
    foldersList: jspb.Message.toObjectList(msg.getFoldersList(),
    icws_proto_icws_api_gateway_storage_base_pb.Folder.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.InkCapture.ListFolderResponse}
 */
proto.InkCapture.ListFolderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.InkCapture.ListFolderResponse;
  return proto.InkCapture.ListFolderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.InkCapture.ListFolderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.InkCapture.ListFolderResponse}
 */
proto.InkCapture.ListFolderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = new icws_proto_icws_api_gateway_storage_base_pb.Document;
      reader.readMessage(value,icws_proto_icws_api_gateway_storage_base_pb.Document.deserializeBinaryFromReader);
      msg.addDocuments(value);
      break;
    case 3:
      var value = new icws_proto_icws_api_gateway_storage_base_pb.Folder;
      reader.readMessage(value,icws_proto_icws_api_gateway_storage_base_pb.Folder.deserializeBinaryFromReader);
      msg.addFolders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.InkCapture.ListFolderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.InkCapture.ListFolderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.InkCapture.ListFolderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.ListFolderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      icws_proto_icws_api_gateway_storage_base_pb.Document.serializeBinaryToWriter
    );
  }
  f = message.getFoldersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      icws_proto_icws_api_gateway_storage_base_pb.Folder.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.InkCapture.ListFolderResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.ListFolderResponse} returns this
 */
proto.InkCapture.ListFolderResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Document documents = 2;
 * @return {!Array<!proto.InkCapture.Document>}
 */
proto.InkCapture.ListFolderResponse.prototype.getDocumentsList = function() {
  return /** @type{!Array<!proto.InkCapture.Document>} */ (
    jspb.Message.getRepeatedWrapperField(this, icws_proto_icws_api_gateway_storage_base_pb.Document, 2));
};


/**
 * @param {!Array<!proto.InkCapture.Document>} value
 * @return {!proto.InkCapture.ListFolderResponse} returns this
*/
proto.InkCapture.ListFolderResponse.prototype.setDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.InkCapture.Document=} opt_value
 * @param {number=} opt_index
 * @return {!proto.InkCapture.Document}
 */
proto.InkCapture.ListFolderResponse.prototype.addDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.InkCapture.Document, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.InkCapture.ListFolderResponse} returns this
 */
proto.InkCapture.ListFolderResponse.prototype.clearDocumentsList = function() {
  return this.setDocumentsList([]);
};


/**
 * repeated Folder folders = 3;
 * @return {!Array<!proto.InkCapture.Folder>}
 */
proto.InkCapture.ListFolderResponse.prototype.getFoldersList = function() {
  return /** @type{!Array<!proto.InkCapture.Folder>} */ (
    jspb.Message.getRepeatedWrapperField(this, icws_proto_icws_api_gateway_storage_base_pb.Folder, 3));
};


/**
 * @param {!Array<!proto.InkCapture.Folder>} value
 * @return {!proto.InkCapture.ListFolderResponse} returns this
*/
proto.InkCapture.ListFolderResponse.prototype.setFoldersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.InkCapture.Folder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.InkCapture.Folder}
 */
proto.InkCapture.ListFolderResponse.prototype.addFolders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.InkCapture.Folder, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.InkCapture.ListFolderResponse} returns this
 */
proto.InkCapture.ListFolderResponse.prototype.clearFoldersList = function() {
  return this.setFoldersList([]);
};


goog.object.extend(exports, proto.InkCapture);
